import React, { useEffect, useRef, useState } from "react"
import { Datagrid, BulkDeleteButton, ListContextProvider, useDataProvider, useDelete, useDeleteMany, useGetMany, useGetOne, useList, useListContext, useNotify, useRecordContext, useRedirect, useRefresh, useUnselect, useUnselectAll, WrapperField } from "react-admin"
import { Dialog, DialogActions, DialogTitle, Backdrop, Box, Button, CircularProgress, FormControlLabel, IconButton, List, ListItem, ListItemAvatar, ListItemText, Switch, TextField, Typography } from "@mui/material";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { GalleryItemModal } from "src/components/gallery/GalleryItemModal";
import { queryString, toDataURL } from "src/common/UtilFunctions";
import HttpClient from "src/providers/HttpClient";
import ApiResources from "src/providers/ApiResources";
import { SizeDialog } from "src/components/gallery/SizeDialog";
import { AdditionalImageEditModal } from "src/components/gallery/AdditionalImageEditModal";
import MultipartUpload from "src/providers/MultipartUpload";

const BulkActionButtons = (props) => {
    let handleDelete = props.handleDelete;
    const { selectedIds, resource, data:listContextData } = useListContext();
    const [deleteMany, { data, isLoading, error }] = useDeleteMany();
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselect = useUnselect('gallery');

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteDeep = () => {
        listContextData.forEach(item => {
            deleteImage(item.image);

            if (item.hasOwnProperty('additional')) {
                Object.keys(item.additional).forEach(function(key) {
                    deleteImage(item.additional[key]);
                });
            }
        });

    };

    const deleteImage = (file) => {
        HttpClient(ApiResources.deleteMediaItem(), {
            method: "DELETE",
            body: JSON.stringify({file: file})
        }).then(({ json }) => {
            if (json.code === 200) {
                notify(`Removed image: ${file}`, { type: 'success' });
            }
        }).catch(error => {
            notify(error.message, { type: 'error' });
        });
    };

    function deleteGalleryItem(){
        deleteMany(
            'admin/product/gallery',
            { ids: selectedIds },
            {
                onSuccess: ()=>{
                    setOpen(false);
                    refresh();
                    notify('Gallery Items Deleted');
                    unselect(selectedIds);
                    let unselectButton:any = document.querySelector("#tabpanel-6 > div > div.css-1ydcb1f-RaBulkActionsToolbar-root > div > div.RaBulkActionsToolbar-title > button");
                    unselectButton?.click();
                    handleDelete();
                    handleDeleteDeep();
                },
                onError: error => notify('Error: Gallery Items not deleted', { type: 'error' }),
            }
        )
    }

    return(    
        <>
            <Button variant="text" startIcon={<DeleteIcon/>} sx={{color:'red', ":hover":{backgroundColor:'rgba(255,0,0,0.1)'}}} onClick={() => setOpen(true)}>
                Delete
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Are you sure you want to remove?`}
                </DialogTitle>
                <DialogActions>
                <Button variant="contained" onClick={deleteGalleryItem} autoFocus>Remove</Button>
                <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};




const CustomImageField = () =>{
    const record = useRecordContext()
    return (
        <img src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${record.image}`} height="100px" />
    );
}

const AddNewSizeButton = (props) =>{
    const refreshDataGrid = props.refresh;
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openSizeDialog, setOpenSizeDialog] = useState(false);
    const [selectedSize, setSelectedSize] = React.useState<any>({});
    const [uploading, setUploading] = useState(false);
    const [choosenImage, setChoosenImage] = useState({});
    const allSizes = [
        {
            name: "Base Image (1200x675)",
            option: "base_image",
            resolution: [1200, 675],
        },
        {
            name: "Vertical Image (700x1000)",
            option: "vertical_image",
            resolution: [700, 1000],
        },
        {
            name: "Small Image (355x355)",
            option: "small_image",
            resolution: [355, 355],
        },
        {
            name: "Thumbnail (80x80)",
            option: "thumbnail",
            resolution: [80, 80],
        },
    ]
    
    const [sizes, setSizes] = useState(allSizes)
    const [newSizeDisabled, setNewSizeDisabled] = useState(false);

    useEffect(() => {
        toDataURL(`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${record.image}`).then(dataUrl=>{
            

            setChoosenImage({previewImage:dataUrl})
            setNewSizeDisabled(false);
        }).catch(err=>{
            console.log(err);
            setNewSizeDisabled(true);
        });
    }, [])
    

    function addNewSize(){
        let addSizes = JSON.parse(JSON.stringify(allSizes));
        if(record.additional && Object.keys(record.additional).length > 0){
            Object.keys(record.additional).forEach(addImg=>{
                addSizes = addSizes.filter(item=>!addImg.includes(item.option))
            })
        }
        setSizes(addSizes);
        setOpenSizeDialog(true);
    }

    function handleCloseSizeDialog(size){
        setOpenSizeDialog(false);

        if(size){
            setSelectedSize(size);
            setOpenEditModal(true);
        }
    };

    function handleCloseAdditionalImageEditDialog(transformedImage:any){
        setOpenEditModal(false);

        setUploading(true);
        var img = new Image();
        img.src = transformedImage;
        img.onload = () => {
          var canvas = document.createElement("canvas");
          var imgwidth = img.width;
          var imgheight = img.height;
          canvas.width = selectedSize.resolution[0];
          canvas.height = selectedSize.resolution[1];
          var ctx = canvas.getContext("2d");
          ctx.drawImage(
            img, 0, 0, imgwidth, imgheight, 0, 0, canvas.width, canvas.height
          );
          canvas.toBlob(function(blob){
            let resizedImageUrl = URL.createObjectURL(blob);
            let imageSize = {...selectedSize}
            if(imageSize.name === "Custom")
              imageSize.name = imageSize.name+" ("+imageSize.resolution[0]+"x"+imageSize.resolution[1]+")"
            
            let originalFilename = record.image.replace(/^.*[\\\/]/, '').replace(/\.[^/.]+$/, '');
            let originalFileExtension = record.image.substring(record.image.lastIndexOf('.'));

            let fileSize = "";
            if(imageSize.option !== "custom") {
                fileSize = imageSize.option
            } else {
                fileSize = imageSize.resolution[0]+"x"+imageSize.resolution[1]
            }

            let fileName = originalFilename+"_"+fileSize+originalFileExtension

            const data = new FormData();
            data.append("images[]", blob, fileName);

            MultipartUpload(ApiResources.postProductImage(record.product.id), data).then(res=>res.json())
            .then(async res=>{
                let galleryItem = {...record};
                delete galleryItem['id'];
                delete galleryItem['created_at'];
                delete galleryItem['updated_at'];
                galleryItem.product = record.product.id;
                galleryItem.sortOrder = galleryItem.sort_order
                delete galleryItem['sort_order'];

                if(!galleryItem.additional)
                    galleryItem.additional = {}
                const image = res[0].file
                galleryItem.additional[fileSize] = image;
                galleryItem.featured = record.featured.toString();
                let galleryItemId = record.id;
                dataProvider.update(ApiResources.updateProductGallery(false),{id: galleryItemId , data: galleryItem, previousData: record}).then(({})=>{
                    setUploading(false);
                    refreshDataGrid();
                })
            });
          },'image/png');
        }
    }

    return (
        <>
            <Button variant="contained"  startIcon={<AddCircleIcon />} onClick={addNewSize} disabled={newSizeDisabled}>Add New Size</Button>
            <SizeDialog sizeOptions={sizes} open={openSizeDialog} onClose={handleCloseSizeDialog} />
            <AdditionalImageEditModal image={choosenImage} imageSize={selectedSize} open={openEditModal} setOpen={setOpenEditModal} onClose={handleCloseAdditionalImageEditDialog}/>


            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={uploading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

const GalleryItemPanel = (props) => {
    const record = useRecordContext();
    const dataProvider = useDataProvider();
    const handleRemove = props.handleRemove;
    const [open, setOpen] = useState(false);
    const [additionalImage, setAdditionalImage] = useState(null);
    const notify = useNotify();

    const handleClose = () => {
        setOpen(false);
        setAdditionalImage(null);
    };

    const handleRemoveAdditionalImage = (additionalImage) => {
        setOpen(true);
        setAdditionalImage(additionalImage);
    };

    const deleteImage = (file) => {
        HttpClient(ApiResources.deleteMediaItem(), {
            method: "DELETE",
            body: JSON.stringify({file: file})
        }).then(({ json }) => {
            if (json.code === 200) {
                notify(`Removed image: ${file}`, { type: 'success' });
            }
        }).catch(error => {
            notify(error.message, { type: 'error' });
        });
    };

    function removeAdditionalImage(){
        let galleryItem = JSON.parse(JSON.stringify(record));
        let galleryItemId = galleryItem.id;
        let galleryAdditionalImage = galleryItem.additional[additionalImage];

        delete galleryItem.additional[additionalImage]
        delete galleryItem['id']
        delete galleryItem['created_at']
        delete galleryItem['updated_at']
        delete galleryItem['sort_order']
        galleryItem.product = record.product.id
        galleryItem.sortOrder = record.sort_order;
        galleryItem.featured = record.featured.toString();
        dataProvider.update(ApiResources.updateProductGallery(false),{id: galleryItemId , data: galleryItem, previousData: record}).then(({})=>{
            setOpen(false);
            setAdditionalImage(null);
            handleRemove();
            deleteImage(galleryAdditionalImage);
        })
    }

    if(!record.additional)
        return <h5>No Additional Images</h5>

    return (
        <>
        <Box style={{marginLeft:'185px'}}>
            <List dense={false}>
            {record && Object.keys(record.additional).map((key,index) =>(
                <ListItem
                    key={index}
                  secondaryAction={
                    <Button variant="outlined" startIcon={<DeleteIcon />} onClick={()=>handleRemoveAdditionalImage(key)} >
                        Remove
                    </Button>
                  }
                  sx={{
                    '.MuiListItemSecondaryAction-root':{
                        marginRight:'5%'
                    },
                    '.MuiListItemText-primary, .MuiListItemText-root':{
                        marginRight:0
                    }
                }}
                >
                  <ListItemAvatar style={{minWidth:'200px'}}>
                    <img src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${record.additional[key]}`} height="80px" style={{maxWidth:"200px"}}></img>
                  </ListItemAvatar>
                  <ListItemText
                    primary={ <React.Fragment>
                        <Typography
                          sx={{ pl:"16%" }}
                          component="span"
                          variant="body1"
                          fontWeight="bold"
                          color="text.primary"
                          maxWidth="100px"
                          textAlign='left'
                        >
                          {key}
                        </Typography>
                      </React.Fragment>
                      }
                  />
                </ListItem>
                ))}
            </List>
        </Box>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Are you sure you want to remove?`}
            </DialogTitle>
            <DialogActions>
            <Button variant="contained" onClick={removeAdditionalImage} autoFocus>Remove</Button>
            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
        </>
    );
};

const GalleryItemNameField = (props) =>{
    const data = props.data;
    const setData = props.setData;
    const record = useRecordContext();
    const [name, setName] = useState(record.name);

    function changeItemName(e){
        let value = e.target.value;
        var myRegEx  = /[a-zA-Z0-9_.-]*/;
        var isValid = !(myRegEx.test(value));


        let allItems = JSON.parse(JSON.stringify(data));
        let currentIndex = allItems.findIndex(item=>item.id === record.id);
        allItems[currentIndex].name = value.replace(/[^a-z0-9]/gi, '');
        setName(value.replace(/[^a-z0-9]/gi, ''));
        setData(allItems);
    }

    return (
        <TextField variant="outlined" label="Gallery Item Name" value={name} onChange={changeItemName}/>
    );
}

const FeaturedField = (props) =>{
    const data = props.data;
    const setData = props.setData;
    const record = useRecordContext();
    const [featuredChecked, setFeatureChecked] = useState(record.featured);

    const featuredChanged = () =>{
        let allItems = JSON.parse(JSON.stringify(data));
        let currentIndex = allItems.findIndex(item=>item.id === record.id);
        allItems[currentIndex].featured = !featuredChecked;
        setFeatureChecked(!featuredChecked);
        setData(allItems);
    }

    return (
        <FormControlLabel control={<Switch checked={featuredChecked==='true' || featuredChecked===true} onChange={featuredChanged}/>} label="Featured" />
    )
}

const SortField = (props) =>{
    const data = props.data;
    const setData = props.setData;
    const record = useRecordContext();

    function moveItemUp(){
        let allItems = JSON.parse(JSON.stringify(data));
        let currentItem = JSON.parse(JSON.stringify(record));
        let currentIndex = allItems.findIndex(item=>item.id === currentItem.id);

        if(currentIndex === 0)
            return;
        
        allItems[currentIndex] = allItems[currentIndex-1] 
        allItems[currentIndex-1] = currentItem

        sortGalleryItems(allItems);
    }

    function sortGalleryItems(allItems){
        for(let i=0;i<allItems.length;i++){
            allItems[i].sort_order = i;
        }
        setData(allItems);
    }
    
    function moveItemDown(){
        let allItems = JSON.parse(JSON.stringify(data));
        let currentItem = JSON.parse(JSON.stringify(record));
        let currentIndex = allItems.findIndex(item=>item.id === currentItem.id);

        if(currentIndex === allItems.length-1)
            return;
        
        allItems[currentIndex] = allItems[currentIndex+1] 
        allItems[currentIndex+1] = currentItem

        sortGalleryItems(allItems);
    }


    return (
        <>
            <IconButton onClick={moveItemUp}>
                <ArrowCircleUpIcon></ArrowCircleUpIcon>
            </IconButton>
            <IconButton onClick={moveItemDown}>
                <ArrowCircleDownIcon></ArrowCircleDownIcon>
            </IconButton>
        </>
    )
}

export const GalleryTab = ({setGalleryItems}) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const product = useRecordContext();
    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const gallery = useList({data, isLoading});
    const [openModal, setOpenModal] = useState(false); 
    const [sortOrder, setSortOrder] = useState(0);

    useEffect(() => {
        updateData();
        
    }, [])

    useEffect(() => {
        if(data){
            setIsLoading(false);
            setGalleryItems(data);
        }
    }, [data])
    

    function updateData(){
        const query = {
            productId:product?.id
        };

        HttpClient(ApiResources.getProductGallery(queryString(query)), {
            method: 'GET'
        }).then(({ json }) => {
            let result = json.results as any
            result = result.sort((a, b)=> a.sort_order - b.sort_order);
            setSortOrder(result[result.length-1]?.sort_order+1)
            setData(result)
        }).catch(error => {
            notify(error.message, { type: 'error' });
        });
    }


    function handleCloseGalleryItemModal(){
        setOpenModal(false);
        updateData();
    }

    function handleDelete(){
        updateData();
    }

    const datagridStyle = {
        width:'100% !important',
        marginTop:'30px',
        '& .RaDatagrid-expandIconCell':{
            width:'120px'
        },
        '& .RaDatagrid-expandIcon':{
            transform: "None !important",
            fontSize:'1rem',
            borderRadius: "4px",
            color:'#1976d2'
        },
        '& .RaDatagrid-expandIcon:not(.RaDatagrid-expanded) svg':{
            transform: 'rotate(-90deg)'
        },
        '& .RaDatagrid-expandIcon:not(.RaDatagrid-expanded)::before':{
            content: '"View Sizes"',
        },
        '& .RaDatagrid-expandIcon::before':{
            content: '"Hide sizes"',
        },
        ' .MuiTableCell-paddingCheckbox':{
            backgoundColor:'red !important'
        },
        '& .RaDatagrid-selectable td:nth-of-type(2)':{
            paddingLeft:'1rem'
        }

    }

    const CustomEmpty = () => <div>No Gallery Items</div>;

    return (        
        <React.Fragment>
            {(data && gallery) && <ListContextProvider value={gallery} >
                <Datagrid data={data} expand={<GalleryItemPanel handleRemove={handleDelete}/>} size="medium"
                    sx={datagridStyle} expandSingle isRowExpandable={record => record.additional} empty={<CustomEmpty/>}
                    bulkActionButtons={<BulkActionButtons handleDelete={handleDelete}/>}
                >
                    <WrapperField label="Image" sortable={false} >
                        <Box sx={{justifyContent:'left', alignItems:'center', width:'100%', display:'grid',rowGap:'10px'}}>
                            <CustomImageField/>
                            <AddNewSizeButton refresh={updateData}/>
                        </Box>
                    </WrapperField>
                    <WrapperField label="Name" sortable={false} >
                        <GalleryItemNameField data={data} setData={setData}/>
                    </WrapperField>
                    <WrapperField label="Featured" sortable={false} >
                        <FeaturedField data={data} setData={setData}/>
                    </WrapperField>
                    <WrapperField label="Sort" sortable={false}>
                        <SortField data={data} setData={setData}/>
                    </WrapperField>
                </Datagrid>
            </ListContextProvider>}
            <Button variant="contained" style={{marginTop:'20px'}} onClick={()=>setOpenModal(true)} startIcon={<AddCircleIcon />}>Add New Gallery Item</Button>
            {(data && gallery) && <GalleryItemModal open={openModal} setOpen={setOpenModal} sortOrder={sortOrder | 0} handleClose={handleCloseGalleryItemModal}/>}
            
        </React.Fragment>
    )

}